import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import DeactivatedSupplementMessage from '@components/DeactivatedSupplementMessage/DeactivatedSupplementMessage';
import RichContent from '@components/RichContent/RichContent';
import RiskLevelButton from '@components/RiskLevelButton/RiskLevelButton';
import ViewProductPageButton from '@components/ViewProductPageButton/ViewProductPageButton';
import useRiskLevelById from '@store/hooks/useRiskLevelById';
import useSupplementCategoryById from '@store/hooks/useSupplementCategoryById';
import { getParsedText } from '@views/AdminInquiriesPage/AdminInquiryList/SupplementInquiryDetails/SupplementInformationForm/utils';

import SupplementResponseDetailsField from './SupplementResponseDetailsField/SupplementResponseDetailsField';
import { ISupplementResponseDetailsBodyProps } from './SupplementResponseDetailsBody.interface';

import './style.scss';

const SupplementResponseDetailsBody: FC<ISupplementResponseDetailsBodyProps> = ({
  data,
  onShowRiskLevelModal,
}) => {
  const { t } = useTranslation();

  const supplementCategory = useSupplementCategoryById(data?.supplementCategoryId);

  const riskLevel = useRiskLevelById(data.riskLevelId);

  return (
    <div className="supplement-response-details-body">
      <Typography variant="h3" className="supplement-response-details-body__title">
        {data.name}
      </Typography>

      {!data.isActive && (
        <DeactivatedSupplementMessage className="supplement-response-details-body__deactivated" />
      )}

      <SupplementResponseDetailsField label={t('inquiryResponse.company')}>
        {data.supplementCompanyName || '-'}
      </SupplementResponseDetailsField>

      <SupplementResponseDetailsField label={t('inquiryResponse.riskLevel')}>
        {riskLevel ? <RiskLevelButton riskLevel={riskLevel} onClick={onShowRiskLevelModal} /> : '-'}
      </SupplementResponseDetailsField>

      <SupplementResponseDetailsField label={t('inquiryResponse.category')}>
        {supplementCategory?.name || '-'}
      </SupplementResponseDetailsField>

      <ViewProductPageButton
        linkToProductPage={data.productLink}
        className="supplement-response-details-body__link"
      />

      <SupplementResponseDetailsField label={t('inquiryResponse.drugClass')}>
        {data.drugClassNames?.join(', ') || '-'}
      </SupplementResponseDetailsField>

      <SupplementResponseDetailsField label={t('inquiryResponse.ingredients')}>
        {data.ingredientNames?.join(', ') || '-'}
      </SupplementResponseDetailsField>

      <SupplementResponseDetailsField label={t('inquiryResponse.comments')}>
        {data.comments ? (
          <RichContent className="supplement-response-details-body__comments">
            {getParsedText(data.comments)}
          </RichContent>
        ) : (
          '-'
        )}
      </SupplementResponseDetailsField>
    </div>
  );
};

export default SupplementResponseDetailsBody;
